import React, { useEffect, useState } from 'react';
type CountdownProps = {
  compact?: boolean;
  dark?: boolean;
};
function pad(value: number) {
  return String(value).padStart(2, '0');
}
export function Countdown({
  compact = false,
  dark = true
}: CountdownProps) {
  const [seconds, setSeconds] = useState(23 * 3600 + 45 * 60 + 33);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(current => Math.max(0, current - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const parts = [{
    label: 'HOURS',
    value: Math.floor(seconds / 3600)
  }, {
    label: 'MIN',
    value: Math.floor(seconds % 3600 / 60)
  }, {
    label: 'SEC',
    value: seconds % 60
  }];
  if (compact) {
    return <span className="font-semibold tabular-nums" data-id="element-55" data-mp="373ugcvxfnjg9">{pad(parts[0].value)} HOURS : {pad(parts[1].value)} MIN : {pad(parts[2].value)} SEC</span>;
  }
  return <div className="flex items-start justify-center gap-2 sm:gap-3" aria-live="polite" data-id="element-56" data-mp="10aino5c7kn8d">
      {parts.map((part, index) => <React.Fragment key={part.label} data-id="element-57" data-mp="y0wvpooum2m2" data-mpi={index}>
          <div className={`min-w-[72px] rounded-xl px-3 py-3 text-center sm:min-w-[94px] sm:px-4 ${dark ? 'bg-navy text-white' : 'border border-sage/30 bg-white text-navy'}`} data-id="element-58" data-mp="xzvf74p2cnwy">
            <div className="text-2xl font-bold tabular-nums sm:text-3xl" data-id="element-59" data-mp="17r9cr6xgfdng">{pad(part.value)}</div>
            <div className={`mt-1 text-[9px] font-bold tracking-[0.18em] ${dark ? 'text-white/60' : 'text-slate'}`} data-id="element-60" data-mp="12rmxkry2fnc0">{part.label}</div>
          </div>
          {index < parts.length - 1 && <span className={`pt-3 text-2xl font-serif ${dark ? 'text-sage-light' : 'text-sage'}`} data-id="element-61" data-mp="a3hcg433nwbn">:</span>}
        </React.Fragment>)}
    </div>;
}